import axios from 'axios';

const ERR_CANCELED = 'ERR_CANCELED';
const CanceledError = 'CanceledError';
const AbortError = 'AbortError';

export const HTTP_ERRORS = {
  ERR_CANCELED,
  CanceledError,
  AbortError,
};

export const isAbortedRequestError = (error: any): boolean => {
  return (
    axios.isCancel(error) ||
    error?.code === ERR_CANCELED ||
    error?.name === CanceledError ||
    error?.name === AbortError
  );
};
